import React, { useRef, useState } from 'react';
import { Icon } from '../../../../../../base/components/Icon';
import { SortDirection } from '../../../../../../base/enums';
import { __t } from '../../../../../../base/utils/t';

import './styles.scss';

interface Props {
    id: string;
    title: string;
    sortDirection: SortDirection | null;
    onSortHandler: (column: string, direction: SortDirection) => void;
}

export const SortingColumn = ({ id, title, sortDirection, onSortHandler }: Props) => {
    const sortButtonRef = useRef<HTMLDivElement>(null);
    const popupRef = useRef<HTMLDivElement>(null);
    const [showPopup, setShowPopup] = useState(false);

    const onAscSortClick = () => {
        setShowPopup(false);
        onSortHandler(id, SortDirection.Asc);
    };

    const onDescSortClick = () => {
        setShowPopup(false);
        onSortHandler(id, SortDirection.Desc);
    };

    const onSortButtonClick = () => {
        setShowPopup(true);
        if (sortButtonRef && sortButtonRef.current) {
            const sortButtonWidth = sortButtonRef.current.offsetWidth;
            const sortButtonHeight = sortButtonRef.current.offsetHeight;

            if (popupRef && popupRef.current) {
                const popupWidth = popupRef.current.offsetWidth;
                popupRef.current.style.top = `${sortButtonHeight + 10}px`;
                popupRef.current.style.left = `calc(-1 * ((${popupWidth}px - ${sortButtonWidth}px) / 2))`;
            }
        }
    };

    return (
        <>
            <div className='vacancy-table-sort'>
                <div className='vacancy-table-sort__button' onClick={onSortButtonClick} ref={sortButtonRef}>
                    {title}
                    <div className='vacancy-table-sort__arrows-wrap'>
                        <Icon
                            className='vacancy-table-sort__arrow'
                            icon='caret-up-solid'
                            size='8'
                            color={sortDirection === SortDirection.Asc ? 'default' : 'info'}
                        />
                        <Icon
                            className='vacancy-table-sort__arrow'
                            icon='caret-down-solid'
                            size='8'
                            color={sortDirection === SortDirection.Desc ? 'default' : 'info'}
                        />
                    </div>
                </div>
                <div
                    className={`vacancy-table-sort__sorting-popup ${
                        showPopup
                            ? 'vacancy-table-sort__sorting-popup--visible'
                            : 'vacancy-table-sort__sorting-popup--hidden'
                    }`}
                    ref={popupRef}
                >
                    <div className='vacancy-table-sort__sorting-popup-item' onClick={onAscSortClick}>
                        <Icon className='vacancy-table-sort__sorting-popup-icon' icon='arrow-up' size='20' />
                        {__t('По возростанию')}
                    </div>
                    <div className='vacancy-table-sort__sorting-popup-item' onClick={onDescSortClick}>
                        <Icon className='vacancy-table-sort__sorting-popup-icon' icon='arrow-down' size='20' />
                        {__t('По убыванию')}
                    </div>
                </div>
            </div>
            {showPopup && <div className='vacancy-table-sort__overlay' onClick={() => setShowPopup(false)}></div>}
        </>
    );
};
